<template>
  <!-- No internal transition here; the parent handles the transition -->
  <v-alert
    :type="notification.ToastVariant"
    closable
    :icon="false"
    density="compact"
    variant="flat"
    class="notification-alert"
    @click:close="dismiss"
  >
    {{ notification.message }}
  </v-alert>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import INotification from '@/interfaces/INotification';
import { useNotificationStore } from '@/store/notificationStore';
import { useAutoDismiss } from '@/composables/useAutoDismiss';

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
  notificationIndex: {
    type: Number,
    required: true,
  },
});

const notificationStore = useNotificationStore();

// The dismiss function updates the store to hide the notification.
function dismiss() {
  notificationStore.updateNotificationVisibility(props.notification, false);
}

// Compute the delay using the store's getter.
const delay = notificationStore.getAutoDismissDelay(props.notificationIndex);

// Use the composable to automatically call dismiss() after the delay.
useAutoDismiss(dismiss, delay);
</script>

<style scoped>
.notification-alert {
  font-size: 0.8rem;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
